// extracted by mini-css-extract-plugin
export default {"Tooltip":"cGVnz6gNpm0hGHVTkwWU","lightTheme":"xx7_tP3phEilWW6Gl0V5"};